const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  device: state => state.app.device,
  dict: state => state.dict.dict,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  userId:state => state.user.id,
  introduction: state => state.user.introduction,
  roles: state => state.user.roles,
  permissions: state => state.user.permissions,
  permission_routes: state => state.permission.routes,
  topbarRouters:state => state.permission.topbarRouters,
  defaultRoutes:state => state.permission.defaultRoutes,
  sidebarRouters:state => state.permission.sidebarRouters,
  refreshView:state => state.refreshView,
  isClientCompany:state =>state.user.isClientCompany,
  companyId:state=>state.user.companyId,
  companyName:state=>state.user.companyName,
  phonenumber:state=>state.user.phonenumber,
  ModalShow:state=>state.user.ModalShow,
  userEmail:state=>state.user.userEmail,
  typeAndBrand:state=>state.user.typeAndBrand,
  guidanceList:state =>state.user.guidanceList,
  startDialog:state =>state.user.startDialog,
  tin:state =>state.user.tin,
}
export default getters
